import { combineReducers } from 'redux';

import alerts from './component/alert/alertsRedux';
import dashboardState from './modules/dashboard/redux/dashboardReducer';
import layoutState from './layout/redux/layoutReducer';
import moreFiltersState from './modules/dashboard/moreFilters/redux/moreFiltersReducer';
import moreInfosState from './modules/dashboard/moreInfos/redux/moreInfosReducer';
import bigNumbersState from './modules/dashboard/bigNumbers/redux/bigNumbersReducer';
import chartsState from './modules/dashboard/charts/redux/charts.reducer';
import dataLayersState from './modules/dashboard/dataLayers/redux/dataLayers.reducer';
import polygonsState from './modules/dashboard/polygons/redux/polygonsReducer';
import marketCycleState from './modules/dashboard/marketCycle/redux/marketCycle.reducer';
import socioeconomicDemographicState from './modules/dashboard/socioeconomicDemographic/redux/socioeconomicDemographic.reducer';
import studiesSlice from './modules/dashboard/studies/redux/studies.reducer';
import mapSearch from './modules/mapSearch/redux/mapSearch.reducer';
import heatmap from './modules/dashboard/heatmap/redux/heatmap.reducer';
import offersPrimaryState from './modules/dashboard/realtyOffersPrimary/redux/offersPrimary.reducer';
import offersPrimaryGeneralState from './modules/dashboard/realtyOffersPrimaryGeneral/redux/offersPrimary.reducer';
import offersSecondaryState from './modules/dashboard/realtyOffersSecondary/redux/offersSecondary.reducer';
import offersSecondaryGeneralState from './modules/dashboard/realtyOffersSecondaryGeneral/redux/offersSecondary.reducer';
import realtyTransactionsState from './modules/dashboard/realtyTransactions/redux/realtyTransactions.reducer';
import realtyTransactionsGeneralState from './modules/dashboard/realtyTransactionsGeneral/redux/realtyTransactions.reducer';
import { Store } from './helpers';

export const rootReducer = combineReducers({
  alerts,
  bigNumbersState,
  chartsState,
  dashboardState,
  dataLayersState,
  heatmap,
  layoutState,
  mapSearch,
  marketCycleState,
  moreFiltersState,
  moreInfosState,
  offersPrimaryGeneralState,
  offersPrimaryState,
  offersSecondaryGeneralState,
  offersSecondaryState,
  polygonsState,
  realtyTransactionsGeneralState,
  realtyTransactionsState,
  socioeconomicDemographicState,
  studies: studiesSlice,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof Store.dispatch;
